import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getAllQuickReplies,
  matchSlashQuery,
  filterQuickReplies,
  applyQuickReply,
} from '../utils/quickReplies';

export function useQuickRepliesKeyboard(
  content: string,
  onSelect: (text: string) => void,
  onEnterSubmit: () => void
) {
  const { t } = useTranslation();
  const [highlightIdx, setHighlightIdx] = useState(0);
  const slashQuery = matchSlashQuery(content);
  const isOpen = slashQuery !== null;
  const filtered = isOpen ? filterQuickReplies(getAllQuickReplies(t), slashQuery) : [];

  useEffect(() => {
    setHighlightIdx(0);
  }, [slashQuery]);

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (isOpen && filtered.length > 0) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setHighlightIdx((i) => (i + 1) % filtered.length);
        return;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setHighlightIdx((i) => (i - 1 + filtered.length) % filtered.length);
        return;
      }
      if (e.key === 'Tab') {
        e.preventDefault();
        onSelect(applyQuickReply(content, filtered[highlightIdx]));
        return;
      }
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        onSelect(applyQuickReply(content, filtered[highlightIdx]));
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        onSelect(content.replace(/(?:^|\s)\/\w*$/, ''));
        return;
      }
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onEnterSubmit();
    }
  };

  return { isOpen, filtered, highlightIdx, setHighlightIdx, onKeyDown };
}
